import Navbar from './Navbar';

export default Navbar;



// WEBPACK FOOTER //
// ./src/comps/Navbar/index.js